"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendConfiguration = void 0;
var qs = require("qs");
exports.backendConfiguration = function (axios) {
    return {
        getOrderConfigsOrder: function (request) {
            return axios.get('/order-configs/order', request);
        },
        putOrderconfigsOrder: function (request) {
            return axios.put("/order-configs/order?mallNo=" + request.params.mallNo, request.data);
        },
        postOrderconfigsOrder: function (request) {
            return axios.post("/order-configs/order?mallNo=" + request.params.mallNo, request.data);
        },
        putOrderconfigsCart: function (request) {
            return axios.put("/order-configs/cart?mallNo=" + request.params.mallNo, request.data);
        },
        getOrderconfigsCart: function (request) {
            return axios.get('/order-configs/cart', request);
        },
        postOrderconfigsCart: function (request) {
            return axios.post("/order-configs/cart?mallNo=" + request.params.mallNo, request.data);
        },
        getOrderConfigsEnums: function () {
            return axios.get('/order-configs/enums');
        },
        getOrderConfigsOrderEnums: function () {
            return axios.get('/order-configs/order/enums');
        },
        putOrderConfigsShipping: function (request) {
            return axios.put("/order-configs/shipping?mallNo=" + request.params.mallNo, request.data);
        },
        getOrderConfigsShipping: function (request) {
            return axios.get('/order-configs/shipping', request);
        },
        postOrderConfigsShipping: function (request) {
            return axios.post("/order-configs/shipping?mallNo=" + request.params.mallNo, request.data);
        },
        getOrderConfigsPaymentsPg: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/order-configs/payments/pg?" + query);
        },
        putOrderConfigsPaymentsPg: function (request) {
            return axios.put('/order-configs/payments/pg', request.data);
        },
        getOrderConfigsPaymentsPayTypes: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/order-configs/payments/pay-types?" + query);
        },
        putOrderConfigsPaymentsPayTypes: function (request) {
            return axios.put('/order-configs/payments/pay-types', request.data);
        },
        getOrderConfigsPaymentsPayco: function (request) {
            return axios.get('/order-configs/payments/payco', request);
        },
        postOrderConfigsPaymentKeysShopByProRenewPGConfigs: function (request) {
            return axios.post('/order-configs/payment-keys/shopby-pro/renew-pg-configs', request.data);
        },
        getOrderConfigsNaverpay: function (request) {
            return axios.get('/order-configs/naverpay', request);
        },
        putOrderConfigsNaverpay: function (request) {
            return axios.put('/order-configs/naverpay', request.data);
        },
        getOrderConfigsNaverEasyPay: function (request) {
            return axios.get('/order-configs/naver-easy-pay', request);
        },
        putOrderConfigsNaverEasyPay: function (request) {
            return axios.put('/order-configs/naver-easy-pay', request.data);
        },
        getOrderConfigsNaverEasyPayV2: function (request) {
            return axios.get('/order-configs/naver-easy-pay', request);
        },
        putOrderConfigsNaverEasyPayV2: function (request) {
            return axios.put('/order-configs/naver-easy-pay', request.data);
        },
        postOrderConfigsPaymentsPayTypesCheck: function (request) {
            return axios.post('/order-configs/payments/pay-types/check', request.data);
        }
    };
};
